import type { AutomationPrompts } from '../../../server/src/modules/operations/automationPrompts.js';

export const AUTOMATION_PROMPT_FIELDS = [
  ['roleProtocol', '角色工具协议', 6],
  ['affinityTool', '亲密系统好感度工具提示词', 7],
  ['imageProtocol', '发图工具协议', 5],
  ['voiceProtocol', '语音工具协议', 5],
  ['timeContext', '当前时间提示（{localTime} 为当前时间）', 3],
  ['quietContext', '勿扰时段提示（{quietPeriods} 为勿扰时段）', 3],
  ['bubbleSchedule', '冒泡定时协议', 5],
  ['momentSchedule', '朋友圈定时协议', 5],
  ['bubbleTask', '自动冒泡任务', 5],
  ['momentTask', '自动朋友圈任务', 5],
  ['momentDecision', '朋友圈自主判断', 6],
  ['taskExecution', '自动任务执行指令', 5],
  ['voiceDecision', '语音发送决策', 5],
  ['voiceDesignProtocol', '角色自动音色设计工具协议', 7],
  ['voiceDesignFull', '角色自动音色设计规则', 5],
  ['voiceDesignDelivery', '角色语音情绪与语速规则', 5],
] as const satisfies readonly (readonly [keyof AutomationPrompts, string, number])[];
